// hides the icon if the esc product hero is used

class ActionToolbar {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
    }

    onInit () {
        const stickyIcon = document.querySelector('.mini-header')
        stickyIcon.style.display = 'none'
    }
}

export default ActionToolbar



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ActionToolbar.js